package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_08_11_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-08-11")
@Composable
public fun Log_2023_08_11(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Tides Turn in the Ambush",
        ogTitle = "Tides Turn in the Ambush",
        date = LocalDate(2_023, 8, 11),
        ogDescription = "The heroes rally against the Venom Trolls and Hobgoblins, utilizing fire and steel to decimate the fleeing enemy.",
        ogImage = "ai/2023-08-11.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
        Log_2023_08_11_Day_1()
    }
}
